import React from 'react';
import { all, fork, take, put, cancel, select, delay } from 'redux-saga/effects';
import { ToastContent, callToast } from '@ts/commons/Toast';
import { savePromocode, loadPromocode } from '@ts/utils/cs';
import api from '@ts/api';

import { trackPromoCodeRequest } from '@ts/utils/iterableUtils';
import actions from '../actions';
import selectors from '../selectors';

export function* onChangeValue() {
    const value = yield select(selectors.promocode.makeSelectValue());

    if (!value) {
        yield put(actions.promocode.changeName(''));
        yield put(actions.promocode.changeModalIsVisible(false));
        yield put(actions.promocode.onValueHasBeenReset());
        return;
    }

    yield put(actions.promocode.onValueHasBeenSet());

    try {
        yield put(actions.promocode.changeIsLoading(true));
        yield delay(50);
        const { name } = yield api.promocode.name(value);

        if (!name) {
            // wrong promo code
            yield put(actions.promocode.changeValue(''));
            trackPromoCodeRequest({
                success: false,
                name: '',
                code: value,
            });
        } else {
            trackPromoCodeRequest({
                success: true,
                name,
                code: value,
            });
            yield put(actions.promocode.changeModalIsVisible(true));
            yield put(actions.promocode.changeName(name));
            yield callToast(
                <ToastContent
                    header={name}
                    text="Thanks for visiting. Today’s discount has been applied to your shopping cart."
                />
            );
        }
    } catch (err) {
        yield put(actions.app.error(err));
        yield put(actions.promocode.changeValue(''));
    } finally {
        yield put(actions.promocode.changeIsLoading(false));
    }
}

export function* watchChangeValue() {
    let task;
    while (true) {
        yield take(actions.promocode.ActionTypes.CHANGE_VALUE);

        if (task) {
            yield cancel(task);
            task = undefined;
        }

        task = yield fork(onChangeValue);
    }
}

export function* watchOnSet() {
    while (true) {
        yield take(actions.promocode.ActionTypes.ON_VALUE_HAS_BEEN_SET);
        const value = yield select(selectors.promocode.makeSelectValue());
        yield savePromocode(value);
    }
}

export function* watchOnReset() {
    while (true) {
        yield take(actions.promocode.ActionTypes.ON_VALUE_HAS_BEEN_RESET);
        yield savePromocode('');
    }
}

export default function* promocodeSaga() {
    yield all([fork(watchOnSet), fork(watchOnReset), fork(watchChangeValue)]);

    const urlSearchParams = new URLSearchParams(window.location.search);
    const searchParams = urlSearchParams.get('promo');
    const promocodeStoraged = searchParams || loadPromocode();

    if (promocodeStoraged && typeof promocodeStoraged === 'string') {
        yield put(actions.promocode.changeValue(promocodeStoraged));
    }
}
